/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import photoNavShape from './PhotoNavigation'

export const barPlotNavFragment = graphql`
  fragment BarPlotNav on ImageSharpConnection {
    all: edges {
      barPlot: node {
        fields {
          slug
          title
        }
      }
    }
  }
`

const raw = PropTypes.shape({
  all: PropTypes.arrayOf(
    PropTypes.shape({
      barPlot: PropTypes.shape({
        fields: photoNavShape.single.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
})

const BarPlotNavigationShape = { ...photoNavShape, raw }

export default BarPlotNavigationShape
